import React from "react";
import { Loader2 } from "lucide-react";
import { Sheet, SheetBody, SheetDescription, SheetFooter, SheetHeader, SheetTitle } from "campaign-builder/ui";
import type { DesignPreviewPage } from "campaign-builder/design/useDesignUpload";
import { DesignAspectPreview } from "./DesignAspectPreview";

interface ReviewUploadModalProps {
  open: boolean;
  pages: DesignPreviewPage[];
  format: string;
  isRendering: boolean;
  isCommitting: boolean;
  onSaveAndContinue: () => void;
  onUploadNew: () => void;
  onClose: () => void;
}

export const ReviewUploadModal: React.FC<ReviewUploadModalProps> = ({
  open,
  pages,
  format,
  isRendering,
  isCommitting,
  onSaveAndContinue,
  onUploadNew,
  onClose,
}) => (
  <Sheet
    open={open}
    onClose={onClose}
    showCloseButton={!isCommitting}
    aria-labelledby="review-upload-title"
    className="max-w-[869px]"
  >
    <SheetHeader>
      <SheetTitle id="review-upload-title">Review uploaded files</SheetTitle>
      <SheetDescription>Review and confirm your uploaded artwork</SheetDescription>
    </SheetHeader>

    <SheetBody>
      {isRendering ? (
        <div className="text-muted-foreground flex flex-col items-center justify-center gap-3 py-20">
          <Loader2 className="h-6 w-6 animate-spin" />
          <p className="text-sm">Preparing preview…</p>
        </div>
      ) : (
        <DesignAspectPreview pages={pages} format={format} />
      )}
    </SheetBody>

    <SheetFooter className="flex items-center justify-end gap-3">
      <button
        type="button"
        onClick={onUploadNew}
        disabled={isRendering || isCommitting}
        className="text-foreground border-border h-9 rounded-lg border border-solid bg-background px-4 text-sm font-medium disabled:opacity-60"
      >
        Upload new file
      </button>
      <button
        type="button"
        onClick={onSaveAndContinue}
        disabled={isRendering || isCommitting}
        className="flex h-9 items-center justify-center gap-2 rounded-lg bg-primary px-4 text-sm font-medium text-primary-foreground disabled:opacity-70"
      >
        Save and continue
        {isCommitting && <Loader2 className="h-4 w-4 animate-spin" />}
      </button>
    </SheetFooter>
  </Sheet>
);
